import React, { Component, Fragment } from 'react';
import { get } from "../../../server/actions";
import ReactTable from 'react-table';
import '../../../../src/assets/css/react-table.css'
import 'bootstrap-daterangepicker/daterangepicker.css';
import { BeatLoader } from 'react-spinners';
import '../../../../node_modules/react-datetime/css/react-datetime.css';
import NotificationSystem from 'react-notification-system';
import PropTypes from "prop-types";
import { _addNotification, _addNotificationError, showFile } from "../../../server/util";

var _ = require('lodash');

class BenefitsIssuanceList extends Component {
    constructor(props) {
        super(props)
        this.state = {
             mealSchoolId:0,
             schoolId:0,
             loading: false,
             benifitsData: [],
             ID: 0,
             studentName: '',
             hdataFilter: { tdate: 'ALL' }
        }
        this.getBenefitsIssuanceData = this.getBenefitsIssuanceData.bind(this)
    }
   
    componentDidMount = () => {
       this._notificationSystem = this.refs.notificationSystem;
        const id = this.props.data;
        const schoolId = this.props.mealSchoolId || this.state.schoolId;
       this.setState({ ID: id, mealSchoolId: schoolId }, () => {
            if (id) {
                this.getBenefitsIssuanceData(id, this.state.hdataFilter.tdate);
            }
        });
    }
    handleRangeChange = (e) => {
        const val = e.target.value;
        if (this.state.hdataFilter && this.state.hdataFilter.tdate === val) return;
        this.setState({ hdataFilter: { tdate: val }, loading: true }, () => {
            const { ID, hdataFilter } = this.state;
        if (ID) {
            this.getBenefitsIssuanceData(ID, hdataFilter.tdate);
        }
        });
    }

    getBenefitsIssuanceData = (id, range = 'ALL', isPdf = false) => {
        const _self = this;
            if (!id) return;

            this.setState({ loading: true });

            let url = `/benefits-issuance-list/student?studentId=${id}`;

            if (range === 'THIS_YEAR') {
                url += `&year=${new Date().getFullYear()}`;
            } else if (range === 'LAST_YEAR') {
                url += `&year=${new Date().getFullYear() - 1}`;
            }

            if (isPdf) {
                url += `&exportType=pdf`;
            }

            url += `&access_token=`; // add token if needed

            get(url)
                .then(response => {
                if (!response.ok) {
                    if (response.status === 417) return response.json();
                    throw Error(response.statusText || 'Network response was not ok');
                }
                return isPdf ? response.blob() : response.json();
                })
                .then(data => {
                if (isPdf) {
                    const filename = `${this.state.studentName || 'benefits'}_issuance.pdf`;
                    showFile(data, filename);
                    this.setState({ loading: false });
                    return;
                }

                const payload = data && data.data ? data.data : data;
                const history = (payload && payload.eligibilityHistory) ? payload.eligibilityHistory : [];
                const studentName = (payload && payload.studentName) ? payload.studentName : '';

                this.setState({
                    benifitsData: history,
                    loading: false,
                    studentName
                });
                })
                .catch(error => {
                        let msg = '';
                        if (typeof error === 'string') msg = error;
                        else if (error && error.message) msg = error.message;
                        else msg = 'Failed to load benefits issuance data';
                        _addNotificationError(msg, _self);
                        this.setState({ loading: false });
          });
    };

    render() {
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (
            <section className="full-width clearfix">
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container ">
                    <div className="sectionTitle">
                        <div className="row">
                            <h2 className="col-md-6" id="deleteLabel">{'Eligibility History :  ' + this.state.studentName}  
                              </h2>
                        </div>
                    </div>
                     <div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-info" style={{ padding: '5px', marginBottom: '5px' }} >
                                <div>
                                    <label className="rbcontainer" style={{marginRight: '10px'}}>
                                        ALL
                                        <input type="radio" name="hdrange" value="ALL"
                                            checked={this.state.hdataFilter.tdate === 'ALL'}
                                            onChange={this.handleRangeChange} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label className="rbcontainer" style={{marginRight: '10px'}}>
                                    This Year
                                        <input type="radio" name="hdrange" value="THIS_YEAR"
                                            checked={this.state.hdataFilter.tdate === 'THIS_YEAR'}
                                            onChange={this.handleRangeChange} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label className="rbcontainer" style={{marginRight: '10px'}}>
                                        Last Year
                                        <input type="radio" name="hdrange" value="LAST_YEAR"
                                            checked={this.state.hdataFilter.tdate === 'LAST_YEAR'}
                                            onChange={this.handleRangeChange} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <a title="Click to Download PDF"
                                        onClick={(e) => { e.preventDefault(); this.getBenefitsIssuanceData(this.state.ID, this.state.hdataFilter.tdate, true); }}
                                        target='_blank'
                                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>
                                </div>
                        </div>
                    </div>
                  </div>
                
                    <ReactTable 
                    columns={[
                        {
                            Header: "Status",
                            accessor: "status",
                            width: 200,
                            style: { textAlign: 'center' },
                        },
                        {
                            Header: "Method",
                            accessor: "method",
                            width: 200,
                            style: { textAlign: 'center' },
                        },
                        {
                            Header: "Date",
                            accessor: "date",
                            width: 200,
                            style: { textAlign: 'center' },
                        }
                   
                    ]} 
                    data={this.state.benifitsData} 
                    defaultPageSize={10} {...checkboxProps} 
                    />
                </div>
            </section>
        )
    }
}
BenefitsIssuanceList.contextTypes = {
    router: PropTypes.object.isRequired
}
export default BenefitsIssuanceList;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SetUpSchool/benefitsIssuanceList.jsx